import React from 'react';
import YouthMentoring from '../components/YouthMentoring';

const YouthMentoringPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <YouthMentoring />
    </div>
  );
};

export default YouthMentoringPage;